import { ACTION_CREATE, ACTION_UPDATE, ACTION_EXTEND } from './interface'
import { createSiteContents, updateSiteContents } from 'services/create-update-site/pro'
import { getSiteContents } from 'services/site'
import { isEmpty } from 'utils/general'

/**
 * Query
 */

export const getSite = async (action, subdomain) => {
  if (![ACTION_CREATE, ACTION_UPDATE].includes(action)) {
    return {
      link: null,
      siteFiles: []
    }
  }

  if (!subdomain) {
    return {
      link: null,
      siteFiles: []
    }
  }

  try {
    const { data } = await getSiteContents({ domain: subdomain, _t: Date.now() })
    const { link, files } = data

    return {
      link,
      siteFiles: files
    }
  } catch (error) {
    if (error instanceof Error) {
      throw error
    }
    throw new Error(String(error))
  }
}

/**
 * Mutation
 */

export const updateSite = async (domain, values, executeRecaptcha, uploadProgress, isPresignedUpload, dispatch) => {
  try {
    const { filesToAdd, indexFile, isZipPhpFile } = values
    const formData = new FormData()

    let link, files
    const originalFiles = [...(filesToAdd || [])]

    for (let i = 0; i < filesToAdd?.length; i++) {
      if (filesToAdd[i].isTemplate === true) {
        formData.append('template', filesToAdd[i].path)
      } else {
        formData.append('filesToAdd', filesToAdd[i])
      }
    }

    if (values.ogImageFile) {
      formData.append('ogImageFile', values.ogImageFile)
    }

    if (values.logoImageFile) {
      formData.append('logoImageFile', values.logoImageFile)
    }

    Object.keys(values).forEach((key) => {
      if (key !== 'filesToAdd' && key !== 'ogImageFile' && key !== 'logoImageFile' && !isEmpty(values[key])) {
        if (key === 'filesToRemove') {
          for (let i = 0; i < values[key].length; i++) {
            formData.append('filesToRemove', JSON.stringify({ id: values[key][i].id, size: values[key][i].size }))
          }
        }

        if (key === 'siteSettings') {
          formData.append(key, JSON.stringify(values[key]))
        }

        if (key === 'newDomain') {
          formData.append(key, values[key])
        }

        if (key === 'indexFile') {
          formData.append('indexFile', indexFile)
        }

        if (key === 'siteType') {
          formData.append(key, values[key])
        }

        if (key === 'isZipPhpFile') {
          formData.append('isZipPhpFile', isZipPhpFile)
        }

        if (key === 'timeZone') {
          formData.append('timeZone', values[key])
        }
      }
    })

    const recaptchaValue = await executeRecaptcha('pro')
    const headers = {
      'x-recaptcha': recaptchaValue
    }

    const updateResponse = await updateSiteContents(
      domain,
      formData,
      headers,
      uploadProgress,
      isPresignedUpload,
      originalFiles,
      dispatch
    )

    if (!updateResponse) {
      throw new Error('updateResponse is null.')
    }

    const { data } = updateResponse

    if (!data) {
      throw new Error('Unexpected empty response from updateSiteContents')
    }

    link = data.link
    files = data.files

    return {
      link: link,
      files: files
    }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const createNewSite = async (values, executeRecaptcha, uploadProgress, dispatch) => {
  try {
    const { filesToAdd, indexFile, isZipPhpFile, spaceId } = values
    const formData = new FormData()

    let link, files, classifierScanFiles

    for (let i = 0; i < filesToAdd?.length; i++) {
      if (filesToAdd[i].isTemplate === true) {
        formData.append('template', filesToAdd[i].path)
      } else {
        formData.append('filesToAdd', filesToAdd[i])
      }
    }

    Object.keys(values).forEach((key) => {
      if (key !== 'filesToAdd' && !isEmpty(values[key])) {
        if (key === 'siteSettings') {
          formData.append(key, JSON.stringify(values[key]))
        }

        if (key === 'newDomain') {
          formData.append(key, values[key])
        }

        if (key === 'domainSuffix') {
          formData.append(key, values[key])
        }

        if (key === 'indexFile') {
          formData.append('indexFile', indexFile)
        }

        if (key === 'siteType') {
          formData.append(key, values[key])
        }

        if (key === 'isZipPhpFile') {
          formData.append('isZipPhpFile', isZipPhpFile)
        }

        if (key === 'timeZone') {
          formData.append('timeZone', values[key])
        }

        if (key === 'spaceId') {
          formData.append('spaceId', spaceId)
        }
      }
    })

    const recaptchaValue = await executeRecaptcha('pro')
    const headers = {
      'x-recaptcha': recaptchaValue
    }

    const response = await createSiteContents(formData, headers, uploadProgress, dispatch)

    if (!response) {
      throw new Error('Upload response is null')
    }

    const { data } = response

    if (!data) {
      throw new Error('Unexpected empty response from createSiteContents')
    }

    link = data.link
    files = data.files
    classifierScanFiles = data.classifierScanFiles

    return {
      link: link,
      files: files,
      classifierScanFiles
    }
  } catch (error) {
    console.error(error)
    throw error
  }
}
